import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Auth } from 'src/app/models/auth';
import { CardSolicitationItem, Solicitation } from 'src/app/models/card-solicitation';
import { UpdateSolicitationItemRequest } from 'src/app/models/request/card-solicitation-request';
import { SolicitationDetailResponse, SolicitationItems } from 'src/app/models/response/card-solicitation-response';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CardSolicitationService } from 'src/app/services/card-solicitation.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

@Component({
  selector: 'app-cartoes-fisicos-pedido-detalhes',
  templateUrl: './cartoes-fisicos-pedido-detalhes.component.html',
  styleUrls: ['./cartoes-fisicos-pedido-detalhes.component.css']
})
export class CartoesFisicosPedidoDetalhesComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private cardSolicitationService: CardSolicitationService
  ) { }

  private currentUser: Auth;
  private routeSubscription: Subscription;
  private id: number;
  public solicitationDetail: SolicitationDetailResponse;
  public address: any;
  public solicitationToCancel: Solicitation;

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.routeSubscription = this.route.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.getSolicitationItens();
  }

  getSolicitationItens(){
    this.cardSolicitationService.solicitationItens(this.id, this.currentUser.token.assignorGuid).subscribe(
      response => {
        if(response.status == ApiError.Sucesso){
          this.solicitationDetail = response.result;
        }
      },
      error => {console.log(error)}
    );
  }

  showCancel(content: any, solicitation: Solicitation) {
      this.solicitationToCancel = solicitation;
      this.modalService.open(content, { centered: true, size: 'lg' });
  }

  cancel(solicitationItem: SolicitationItems) {
      let updateSolicitationRequest = new UpdateSolicitationItemRequest();
      updateSolicitationRequest.assignorGuid = this.currentUser.token.assignorGuid;
      updateSolicitationRequest.managerGuid = this.currentUser.token.userReferenceId;
      updateSolicitationRequest.solicitationId = solicitationItem.solicitationId;
      updateSolicitationRequest.cardSolicitationItem = new CardSolicitationItem();
      updateSolicitationRequest.cardSolicitationItem.solicitationItemId = solicitationItem.solicitationItemId;
      updateSolicitationRequest.cardSolicitationItem.reason = "Item do pedido Cancelado via Portal";
      this.cardSolicitationService.updateSolicitationItem(updateSolicitationRequest).subscribe(
          response => {
          if (response.status === ApiError.Sucesso) {
              this.alertService.success("Item cancelado com sucesso!");
              this.getSolicitationItens();
          } else {
              this.alertService.error(response.message);
          }
          }, error => { this.alertService.error(error); }
      );
  }

  showAddress(content, item: SolicitationItems) {
    this.address = ''
    this.cardSolicitationService.solicitationItemAddress(item.solicitationId, item.solicitationItemId, this.currentUser.token.assignorGuid).subscribe(
      response => {
        if(response.status == ApiError.Sucesso){
          this.address = response.result;
        }
      },
      error => {console.log(error)}
    );

    this.modalService.open(content, { centered: true, size: 'md' });
  }
}
